
import {Component, Mixins, Prop} from 'vue-property-decorator'
import {Radar} from 'vue-chartjs'
import {ChartData, ChartOptions} from 'chart.js'
import Const from '@/util/Const'

@Component
export default class ExposureRadar extends Mixins(Radar) {
  private options: ChartOptions = {
    scale: {
      angleLines: {
        color: 'rgba(255,255,255,0.15)',
      },
      gridLines: {
        display: false,
      },
      ticks: {
        suggestedMin: 0,
        suggestedMax: 100,
        display: false,
      },
      pointLabels: {
        fontSize: 12,
        fontColor: '#D8D8D8',
      },
    },
    legend: {
      display: false,
    },
  }
  @Prop({required: true})
  private exposures!: number[]

  @Prop({required: true})
  private topix!: number

  public mounted() {
    this.renderChart(this.chartData, this.options)
  }

  get chartData(): ChartData {
    return {
      labels: [
        Const.label('Portfolio.Item.item1'),
        Const.label('Portfolio.Item.item2'),
        Const.label('Portfolio.Item.item3'),
        Const.label('Portfolio.Item.item4'),
        Const.label('Portfolio.Item.item5'),
        Const.label('Portfolio.Item.item6'),
        Const.label('Portfolio.Item.item7'),
        Const.label('Portfolio.Item.item8'),
      ],
      datasets: [
        { // main
          data: this.exposures,
          backgroundColor: 'rgba(0,175,240,0.5)',
          borderColor: 'rgba(0, 0, 0, 0)',
          borderWidth: 0,
          pointBorderWidth: 0,
          pointRadius: 0,
          order: 1,
        },
        {
          data: [this.topix, this.topix, 0, 0, this.topix, this.topix, 0, 0],
          backgroundColor: 'rgba(255,255,255,0.4)',
          borderColor: 'rgba(0, 0, 0, 0)',
          borderWidth: 0,
          pointBorderWidth: 0,
          pointRadius: 0,
          order: 10,
        },
        {
          data: [0, this.topix, this.topix, 0, 0, 0, 0, 0],
          backgroundColor: 'rgba(255,255,255,0.5)',
          borderColor: 'rgba(0, 0, 0, 0)',
          borderWidth: 0,
          pointBorderWidth: 0,
          pointRadius: 0,
          order: 10,
        },
        {
          data: [0, 0, this.topix, this.topix, 0, 0, 0, 0],
          backgroundColor: 'rgba(255,255,255,0.65)',
          borderColor: 'rgba(0, 0, 0, 0)',
          borderWidth: 0,
          pointBorderWidth: 0,
          pointRadius: 0,
          order: 5,
        },
        {
          data: [0, 0, 0, this.topix, this.topix, 0, 0, 0],
          backgroundColor: 'rgba(255,255,255,0.5)',
          borderColor: 'rgba(0, 0, 0, 0)',
          borderWidth: 0,
          pointBorderWidth: 0,
          pointRadius: 0,
          order: 10,
        },
        {
          data: [0, 0, 0, 0, 0, this.topix, this.topix, 0],
          backgroundColor: 'rgba(255,255,255,0.3)',
          borderColor: 'rgba(0, 0, 0, 0)',
          borderWidth: 0,
          pointBorderWidth: 0,
          pointRadius: 0,
          order: 10,
        },
        {
          data: [0, 0, 0, 0, 0, 0, this.topix, this.topix],
          backgroundColor: 'rgba(255,255,255,0.2)',
          borderColor: 'rgba(0, 0, 0, 0)',
          borderWidth: 0,
          pointBorderWidth: 0,
          pointRadius: 0,
          order: 5,
        },
        {
          data: [this.topix, 0, 0, 0, 0, 0, 0, this.topix],
          backgroundColor: 'rgba(255,255,255,0.3)',
          borderColor: 'rgba(0, 0, 0, 0)',
          borderWidth: 0,
          pointBorderWidth: 0,
          pointRadius: 0,
          order: 10,
        },
      ],
    }
  }
}
